import React, { useEffect, useCallback } from 'react';

function ImageCarousel({ images, currentIndex, onClose, onNavigate }) {
  const total = images.length;

  const goNext = useCallback(() => {
    onNavigate((currentIndex + 1) % total);
  }, [currentIndex, onNavigate, total]);

  const goPrev = useCallback(() => {
    onNavigate((currentIndex - 1 + total) % total);
  }, [currentIndex, onNavigate, total]);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') goNext();
      if (e.key === 'ArrowLeft') goPrev();
    };

    window.addEventListener('keydown', handleKey);

    return () => {
      window.removeEventListener('keydown', handleKey);
    };
  }, [onClose, goNext, goPrev]);

  const current = images[currentIndex];

  return (
    <div
      className="lightbox"
      role="dialog"
      aria-modal="true"
      aria-label="Image gallery"
      onClick={onClose}
    >
      <div
        className="lightbox__inner"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="lightbox__close"
          onClick={onClose}
          aria-label="Close gallery"
        >
          <span aria-hidden="true">&times;</span>
        </button>

        <button
          type="button"
          className="lightbox__nav lightbox__nav--prev"
          onClick={goPrev}
          aria-label="Previous image"
        >
          <span aria-hidden="true">&#8249;</span>
        </button>

        <figure className="lightbox__figure" key={currentIndex}>
          <div className="lightbox__image-wrap">
            <img
              src={current.src}
              alt={current.alt}
              className="lightbox__image"
            />
            {current.caption && (
              <div className="lightbox__caption-overlay">
                <p className="lightbox__caption-text">{current.caption}</p>
              </div>
            )}
          </div>
          <figcaption className="lightbox__counter">
            {currentIndex + 1} / {total}
          </figcaption>
        </figure>

        <button
          type="button"
          className="lightbox__nav lightbox__nav--next"
          onClick={goNext}
          aria-label="Next image"
        >
          <span aria-hidden="true">&#8250;</span>
        </button>
      </div>
    </div>
  );
}

export default ImageCarousel;
